/**
 * Represents state of test in UI.
 * For example if one of tests of sertain device is in development it shouldn't be shown in production environment in order to not let our customers see it untill it will be ready
 */
export enum TEST_STAGE {
    SHOWN = 'SHOWN',
    HIDDEN = 'HIDDEN',
}
